import React__default from 'react';
import BsRow from 'reactstrap/lib/Row';

const Row = (props) => {
    return React__default.createElement(BsRow, Object.assign({}, props));
};

export { Row as default };
//# sourceMappingURL=Row.js.map
